<template>
  <div>
    <b-container>
      <!-- <b-row>
        <b-col cols="12" md="6" offset-md="3">
          <div v-b-modal.registerModal class="banner">
            <button id="showModelButton" data-bs-toggle="modal" data-bs-target="#exampleModal" class="banner w-100">
            <b-img class="pencil" src="img/pencil.png" width="50" />
            <h1>PREVIEW EVENT COMING SOON</h1>
            <p>Register today to receive insider updates and be invited to an exclusive preview purchasing event at MVP!</p>
            <div v-b-modal.registerModal class="btn btn_register">
              REGISTER NOW
            </div>
            <h1>
              Register Now for
              <br />FIRST ACCESS
            </h1>
          </button>
          
          </div>
        </b-col>
      </b-row> -->
      <div class="contactSection mb-5">
                    <div class="contactBox">
                        <div class="contactInfo mb-4">
                            <p class="contactText mt-4">
                                READY TO FIND
                                <br/>
                                YOUR HOME IN BARRIE?
                            </p>
                            <button type="button" id="showModelButton" data-bs-toggle="modal" data-bs-target="#exampleModal" class="btn btn-lg btnInventory">CONTACT US TODAY!</button>
                        </div>
                        <div class="contactInfo">
                            <p class="textInfo">
                                TEXT/CALL
                            </p>
                            <h1 class="phoneInfo">
                                289.677.1564
                            </h1>
                        </div>
                    </div>
                    <div class="ImageBox">
                        <img src="/img/mvp_map.jpg" class="mvpImage" alt="MVP Map" />
                    </div>
                </div>
    </b-container>
    <RegisterModal />
  </div>
</template>

<script>
import RegisterModal from "~/components/RegisterModal.vue";

export default {
  components: {
    RegisterModal,
  },
};
</script>

<style lang="scss">
.banner {
  text-align: center;
  border: solid 2px #f9ae43;
  border-radius: 6px;
  padding: 15px;
  margin: 20px 0px;
  cursor: pointer;
  position: relative;
  background-color: #f05b2d;
  color: white;

  h1 {
    font-family: "Montserrat", sans-serif;
    font-weight: normal;
    font-size: 35px;
    @media screen and (max-width: 350px) {
      font-size: 30px;
    }
  }

  &:hover {
    background-color: white;
    color: #f9ae43;
  }

}

.pencil {
  position: absolute;
  right: -9px;
  top: -9px;
}

.btn_register {
  background-color: #f05b2d;
  cursor: pointer;
  color: #fff;
  // border: 2px solid #f9ae43;
  border: 2px solid transparent;
  font-size: 0.8rem;
  letter-spacing: 1px;
  padding: 15px 35px;
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
}

.contactSection {
    display: flex;
    justify-content: space-around;
    gap: 20px;
    @media screen and (max-width: 430px) {
        flex-direction: column;
        align-items: center;
    }
}

.contactBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.contactInfo {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    
}

.titleInfo {
    font-weight: bold;
    font-size: 24px;
    letter-spacing: 1px;
    text-align: center;
    color: #000;
    margin: 0;

    @media screen and (max-width: 768px) {
        font-size: 16px;
    }
}

.textInfo {
    font-weight: 500;
    font-size: 30px;
    letter-spacing: 1px;
    text-align: center;
    color: #29AAE1;
    margin: 0;
    @media screen and (max-width: 768px) {
        font-size: 14px;
    }
}

.phoneInfo {
  font-weight: bold;
  font-size: 42px;
  letter-spacing: 1px;
  text-align: center;
  color: #29AAE1;

  @media screen and (max-width: 768px) {
        font-size: 25px;
    }
}

.contactText {
    font-size: 30px;
    line-height: 35px;
    font-weight: 100;
    text-align: left;
    letter-spacing: 1px;
    color: #000;

    @media screen and (max-width: 768px) {
        font-size: 13px;
        line-height: 20px;
    }
}

.mvpImage {
  width: 100%;
  display: flex;
  align-items: flex-start;
}

.btnInventory {
    color: #fff;
    font-size: 30px;
    width: 100%;
    background-color: #F05B2D;
    border-radius: 0;
    cursor: pointer;

    &:hover {
      background-color: white;
      color: #f9ae43;
      border: 2px solid #f9ae43;
    }

    @media screen and (max-width: 768px) {
      font-size: 1rem;
    }
    
}

</style>
